var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('span', [_c('v-divider', {
    staticClass: "mb-4"
  }), _c('p', {
    staticClass: "px-4 title primary--text"
  }, [_vm._v(_vm._s(_vm.$t('Room Objects')))]), _c('v-row', {
    staticStyle: {
      "max-width": "100%"
    }
  }, _vm._l(_vm.list, function (l) {
    return _c('v-col', {
      key: "room-object-tweet-".concat(l[0].m_DBAccessID),
      attrs: {
        "cols": "12",
        "md": "6"
      }
    }, [_c('div', {
      staticClass: "d-flex"
    }, [_c('router-link', {
      attrs: {
        "to": "/roomobject/".concat(l[0].m_DBAccessID)
      }
    }, [_c('div', {
      staticClass: "float-right px-4"
    }, [_c('v-avatar', {
      key: "room-object-icon-".concat(l[0].m_DBAccessID + 1),
      attrs: {
        "size": _vm.$size() * 1.2
      }
    }, [_c('v-img', {
      attrs: {
        "src": _vm.$asset.roomobjecticon.format(_vm.categoryName(l[0].m_Category), l[0].m_ID) + '.jpg'
      }
    })], 1)], 1)]), _c('Voice', {
      staticClass: "mr-2",
      attrs: {
        "name": _vm.name(l[1].m_NamedType),
        "cue": "".concat(l[1].m_VoiceCueName, "_0")
      }
    }), _c('div', {
      staticClass: "d-flex justify-center flex-column"
    }, [_c('div', {
      staticClass: "small",
      staticStyle: {
        "white-space": "nowrap",
        "text-overflow": "ellipsis"
      },
      domProps: {
        "innerHTML": _vm._s(l[1].m_Text.replace(/\n/g, '<br>'))
      }
    })])], 1)]);
  }), 1)], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }